import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {navigateToRoute} from '~/CreateFabricInvitation/navigation';
import {UPDATE_DESIGN_OPTIONS} from '~/CreateFabricInvitation/reducers/fabricDesign/constants';
import {storeTooltipIdToHide} from '~/CreateFabricInvitation/utils/tooltip';

export const useNavigation = ({
  store,
  canvas,
  currentRoute,
  inEditMode,
  usedPremiumFeature,
  premiumFeaturesPristine,
  handleShowUpsell,
}) => {
  const dispatch = useDispatch();

  const stopSubmitting = useCallback(() => {
    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {savingStep: false},
    });
  }, [dispatch]);

  const handleNavigation = useCallback(async () => {
    if (inEditMode) {
      storeTooltipIdToHide(store);
    }
    const {isPremium} = store.getState().details;
    if (!isPremium && (usedPremiumFeature || !premiumFeaturesPristine)) {
      handleShowUpsell();
      return;
    }

    dispatch({
      type: UPDATE_DESIGN_OPTIONS,
      payload: {savingStep: true},
    });

    let navigating = true;

    try {
      navigating = await navigateToRoute(currentRoute.nextRoute, store, false, false, [canvas]);
    } catch (e) {
      navigating = false;
      evite.error('Failed to navigate', e);
    } finally {
      if (!navigating) {
        stopSubmitting();
      }
    }
  }, [
    canvas,
    store,
    currentRoute,
    premiumFeaturesPristine,
    usedPremiumFeature,
    inEditMode,
    handleShowUpsell,
  ]);

  return {
    handleNavigation,
    stopSubmitting,
  };
};
